import React, { forwardRef } from 'react';
import styles from './form.module.scss';

type NumberInputProps = {
    value?: string;
    placeholder?: string;
    addonAfter?: string;
    disabled?: boolean;
    max?: number;
    allowDecimal?: boolean;
    onChange?: (value: string) => void;
};

export const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(
    (
        {
            value = '',
            placeholder,
            addonAfter,
            disabled = false,
            max,
            allowDecimal = false,
            onChange,
        },
        ref,
    ) => {
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            let val = e.target.value;
            const pattern = allowDecimal ? /[^0-9.]/g : /[^0-9]/g;
            val = val.replace(pattern, '');

            if (allowDecimal) {
                const parts = val.split('.');
                if (parts.length > 2) {
                    val = parts[0] + '.' + parts.slice(1).join('');
                }
                if (parts[1]?.length > 2) {
                    val = parts[0] + '.' + parts[1].slice(0, 2);
                }
            }

            if (max !== undefined && val !== '' && Number(val) > max) {
                return;
            }

            onChange?.(val);
        };

        const hasAddon = !!addonAfter;

        return (
            <div className={styles.numberInputRow}>
                <input
                    ref={ref}
                    className={`${styles.numberInput} ${hasAddon ? styles.numberInputHasAddon : ''}`}
                    value={value}
                    placeholder={placeholder}
                    disabled={disabled}
                    inputMode="decimal"
                    onChange={handleChange}
                    autoComplete="off"
                />
                {hasAddon && <span className={styles.addonAfter}>{addonAfter}</span>}
            </div>
        );
    },
);

NumberInput.displayName = 'NumberInput';
